// API клиент для NSI v20_tfoms_style
import { apiClient } from './client'

// Типы
export interface V20TfomsStyleItem {
  idpk_tfoms: number
  profil_k_tfoms_name: string | null
  tfoms_group_code: number
  v020_code: number | null
  v020_name: string | null
}

export interface V020Suggestion {
  idk_pr: number
  k_prname: string
  suggested_tfoms_name: string
}

export interface V20TfomsStyleListResponse {
  items: V20TfomsStyleItem[]
  suggestions: V020Suggestion[]
  total: number
  total_suggestions: number
}

export interface V20TfomsStyleCreate {
  idpk_tfoms: number
  profil_k_tfoms_name: string
  tfoms_group_code?: number
}

export interface V20TfomsStyleUpdate {
  profil_k_tfoms_name?: string
  tfoms_group_code?: number
}

// API функции
export const fetchV20TfomsStyle = async (): Promise<V20TfomsStyleListResponse> => {
  const response = await apiClient.get<V20TfomsStyleListResponse>('/nsi/v20-tfoms-style/')
  return response.data
}

export const createV20TfomsRecord = async (data: V20TfomsStyleCreate): Promise<void> => {
  await apiClient.post('/nsi/v20-tfoms-style/', data)
}

export const updateV20TfomsRecord = async (
  idpk_tfoms: number,
  data: V20TfomsStyleUpdate
): Promise<void> => {
  await apiClient.put(`/nsi/v20-tfoms-style/${idpk_tfoms}`, data)
}

export const deleteV20TfomsRecord = async (idpk_tfoms: number): Promise<void> => {
  await apiClient.delete(`/nsi/v20-tfoms-style/${idpk_tfoms}`)
}
